import React from 'react'

import timeIcon from '../../assets/svg/icon-time.svg'

import './styles/header.scss'

const Header = props => {
  const { videos, orderByName, orderByNewest, orderByOldest } = props

  const handleClick = e => {
    const activeFilter = document.querySelector('.filter.active')

    if (activeFilter) {
      activeFilter.classList.remove('active')
    }

    e.target.classList.add('active')
  }

  return (
    <header className="video-listing-header">
      <h1 className="section-title">The Library</h1>

      <div className="filters-container">
        <p id="filters-label" aria-label="Sort the videos">Sort</p>

        <div className="filters" aria-labelledby="filters-label">
          <button
            type="button"
            className="filter"
            aria-controls="video-listing"
            onClick={e => {
              handleClick(e)
              orderByName(videos)
            }}
          >
            <span>A/Z</span>
          </button>
          <button
            type="button"
            className="filter"
            aria-controls="video-listing"
            onClick={e => {
              handleClick(e)
              orderByNewest(videos)
            }}
          >
            <img src={timeIcon} alt=""/>
            <span>NEW</span>
          </button>
          <button
            type="button"
            className="filter"
            aria-controls="video-listing"
            onClick={e => {
              handleClick(e)
              orderByOldest(videos)
            }}
          >
            <img src={timeIcon} alt=""/>
            <span>OLD</span>
          </button>
        </div>
      </div>
    </header>
  )
}

export default Header